import {TranslationObject} from '@colonist/i18n'
import {createDivIn, createImgIn, createLinkIn, createParagraphIn} from '../../ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'

export interface SidebarTabInterface {
    text: TranslationObject
    class: string
    href: string
    imageSrc: LobbyImage
    id: string
}

export class UISidebarView {
    private readonly parentElement: HTMLElement
    private readonly sidebarTabs: SidebarTabInterface[]

    constructor(parentElement: HTMLElement, sidebarTabs: SidebarTabInterface[]) {
        this.parentElement = parentElement
        this.sidebarTabs = sidebarTabs
        this.createSidebar()
    }

    private createSidebar() {
        const emptyTranslationObject: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
        for(const sidebarTab of this.sidebarTabs) {
            const sidebarButton = createLinkIn(this.parentElement, sidebarTab.href, emptyTranslationObject, 'singleton_page_sidebar_button', sidebarTab.id)
            const sidebarButtonImageContainer = createDivIn(sidebarButton, '')
            createImgIn(sidebarButtonImageContainer, sidebarTab.imageSrc)
            createParagraphIn(sidebarButton, sidebarTab.text, 'singleton_page_sidebar_button_text')
        }
    }
}
